const qs = require('qs')
const { showError } = require('../../libs/helper')

module.exports = {
  getKib: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/ref/get-kib`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  getKobar: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/ref/get-kobar`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => {
      const d = res.data
      if (d.rows) {
        d.rows = d.rows.map(item => ({
          value: item.value,
          text: `${item.value}::${item.text}`, // Change 'text' to 'nama'
        }))
      }
      return d
    }).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  getNoreg: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/ref/get-noreg`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => {
      const d = res.data
      if (d.rows) {
        d.rows = d.rows.map(item => ({
          value: item.value,
          text: `${item.value}::${item.text}${`${(item.ALAMAT ? `::${item.ALAMAT}` : '')}`}`, // Change 'text' to 'nama'
        }))
      }
      return d
    }).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  getWilayah: (g, params = null) => {
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/ref/get-wilayah`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      console.log(err)
    })
    return result
  },
  getKolokDs: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/ref/get-kolok`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  getKategoriHasilSensusDs: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/ref/get-kategori`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  getStatusHasilSensusDs: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/ref/get-status-invent`,
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
}
